import { breakpoints } from '../constants/breakpoints';
import { sizes as whitelist } from '../constants/sizes';

/* @getSizesAtBreakpoint
 * takes a DOM element and returns an array of sizes from the element's
 * data-sizes attributes.
 * eg. <div data-ad="wide" data-sizes-small="320x320"></div>
 */
export function getSizesAtBreakpoint(tag, breakpoint) {
  const sizeArray = {};
  const attrs = [].slice.apply(tag.attributes);
  const breakpointWidth = breakpoints[breakpoint] || breakpoints.small;

  attrs.forEach((attr) => {
    const matches = attr.name.match(/^data-sizes(-([a-z]+))?$/);
    if (matches) {
      let sizeName = matches[2];

      // base or nothing defaults to small
      if (!sizeName || sizeName === 'base') { sizeName = 'small'; }

      const sizeWidth = breakpoints[sizeName];

      // ignore undefined breakpoints
      if (sizeWidth === undefined) { return; }

      // If breakpoint is too large, ignore
      if (sizeWidth > breakpointWidth) { return; }

      const sizes = attr.value.split(',').map((size) => size.split('x'));
      sizes.forEach((size) => {
        // we need a width and a height
        if (size.length < 2) { return; }

        // Match against ad size whitelist
        if (!whitelist.filter((ad) => ad.join('x') === size.join('x')).length) { return; }

        // sizes 0, 1 and 2 are used for dynamic sizes, which we don't support
        if (Math.max(...size) < 10) { return; }

        // if not already done, define the breakpoint in the size array
        if (sizeArray[sizeName] === undefined) { sizeArray[sizeName] = []; }

        // push the size to the size array breakpoint
        sizeArray[sizeName].push([parseInt(size[0], 10), parseInt(size[1], 10)]);
      });
    }
  });
  const largest = Object.keys(sizeArray).sort((a, b) => parseInt(b, 10) - parseInt(a, 10))[0];
  return sizeArray[largest] || [];
}
